var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeniedOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.5C1.5 14.5767 2.11581 16.6068 3.26957 18.3335C4.42332 20.0602 6.0632 21.406 7.98182 22.2007C9.90045 22.9955 12.0116 23.2034 14.0484 22.7982C16.0852 22.3931 17.9562 21.3931 19.4246 19.9246C20.8931 18.4562 21.8931 16.5852 22.2982 14.5484C22.7034 12.5116 22.4955 10.4004 21.7007 8.48182C20.906 6.5632 19.5602 4.92332 17.8335 3.76957C16.1068 2.61581 14.0767 2 12 2C9.21523 2 6.54451 3.10625 4.57538 5.07538C2.60625 7.04451 1.5 9.71523 1.5 12.5ZM18.8625 18.3125L6.1875 5.6375C7.91298 4.20125 10.1129 3.46173 12.3556 3.5641C14.5983 3.66646 16.7218 4.60331 18.3092 6.19077C19.8967 7.77824 20.8335 9.90169 20.9359 12.1444C21.0383 14.3871 20.2988 16.587 18.8625 18.3125ZM6.18 19.37C4.36374 17.8276 3.23325 15.6279 3.03642 13.2533C2.83959 10.8787 3.59248 8.52286 5.13 6.7025L17.7975 19.37C16.1732 20.7425 14.1153 21.4955 11.9887 21.4955C9.86219 21.4955 7.80433 20.7425 6.18 19.37Z",
    fill: "#E7000B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeniedOutline);
export default __webpack_public_path__ + "static/media/ic-denied-outline.9a85fc6fe6cb4430121aecccddca586c.svg";
export { ForwardRef as ReactComponent };